import { Link } from "react-router-dom";
import React from "react";
import { toast } from "react-toastify";
import henceforthApi from "../utils/henceforthApi";
import { GlobalContext } from "../context/Provider";
import { useContext } from "react";

const DbBackup = () => {
  const { authState, authDispatch } = useContext(GlobalContext);
  if(authState.access_token){henceforthApi.setToken(authState.access_token);}
  const backData = {
    language: "ENGLISH",
  };
  const backUpDb = async () => {
    try {
      let apiRes = await henceforthApi.Common.backupDb(backData);
      console.log("apiRes", apiRes);
      let data = apiRes.data;
      let base_url = data.base_url;
      const origin = window.location.origin;
      const openUrl = `${base_url}`.replace(origin, "");
      console.log("loc", openUrl);
      window.open(`${openUrl}`);
    } catch (error:any) {
      console.log("Error", error);
      toast.error(error.response.body.error_description);
    }
  };
return (
    <div className="animated fadeInRight">
      <div className="ibox">
        <div className="ibox-content">
          <div className="mail-box-header text-center">
            <h2>DB CLEAR</h2>
          </div>
          <div className="ibox-content text-center">
            <p>
               If you click on clear, We will clear Db Backup 
            </p>
            <div className="text-secondary text-underline cursor-pointer">
              Db MySql file:{" "}
              <span className="ms-2 text-primary" >
                clear
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DbBackup;
